import { Box as _Box } from "./Box";
import { Del as _Del } from "./Del";
import { Icon as _Icon } from "./Icon";
import { Item as _Item } from "./Item";
import { Menu as _Menu } from "./Menu";
import { List as _List } from "./List";
import { Text as _Text } from "./Text";
import { Form as _Form } from "./Form";
import { Input as _Input } from "./Input";
import { Image as _Image } from "./Image";
import { Label as _Label } from "./Label";
import { Anchor as _Anchor } from "./Anchor";
import { Button as _Button } from "./Button";
import { Select as _Select } from "./Select";
import { Option as _Option } from "./Option";
import { Legend as _Legend } from "./Legend";
import { Heading as _Heading } from "./Heading";
import { Section as _Section } from "./Section";
import { Textarea as _Textarea } from "./Textarea";
import { Fieldset as _Fieldset } from "./Fieldset";

export const Box = _Box as any;
export const Del = _Del as any;
export const Icon = _Icon as any;
export const Item = _Item as any;
export const Menu = _Menu as any;
export const List = _List as any;
export const Text = _Text as any;
export const Form = _Form as any;
export const Input = _Input as any;
export const Image = _Image as any;
export const Label = _Label as any;
export const Anchor = _Anchor as any;
export const Button = _Button as any;
export const Select = _Select as any;
export const Option = _Option as any;
export const Legend = _Legend as any;
export const Heading = _Heading as any;
export const Section = _Section as any;
export const Textarea = _Textarea as any;
export const Fieldset = _Fieldset as any;
